export default {
  condition: 'شرط',
  conditionGroup: 'گروه شرط',
  operator: 'عملگر',
  not: 'NOT (!)',
  areYouSureYouWantToDeleteThisConsition: 'آیا از حذف این شرط اطمینان دارید؟',
  areYouSureYouWantToDeleteThisConsitionGroup:
    'آیا از حذف این گروه شرط اطمینان دارید؟',
  addCondition: 'افزودن شرط',
  equal: 'مساوی (==)',
  notEqual: 'نامساوی (=!)',
  greater: 'بزرگتر (<)',
  greaterEqual: 'بزرگتر مساوی (=<)',
  less: 'کوچکتر (>)',
  lessEqual: 'کوچکتر مساوی (=>)',
  and: 'AND (&&)',
  or: 'OR (||)',
  value: 'مقدار',
  variableName: 'نام متغیر',
  variable: 'متغیر',
  payAttentionOnConditionsDetail: 'در وارد کردن اطلاعات شرط ها دقت کنید',
  like: 'Like (LIKE)',
  enableNot: 'فعال کردن NOT',
  disableNot: 'غیرفعال کردن NOT'
}
